import React from 'react';
import Driver from '../assets/images/driver.svg';

export default () => {
  return <img src={Driver} alt="" />;
};